module.exports = __webpack_public_path__ + "img/恒哥.1f17ecf9.png";